import { render, staticRenderFns } from "./AccommodationLetterDoc.vue?vue&type=template&id=7644632d&scoped=true&"
import script from "./AccommodationLetterDoc.vue?vue&type=script&lang=js&"
export * from "./AccommodationLetterDoc.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationLetterDoc.vue?vue&type=style&index=0&id=7644632d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7644632d",
  null
  
)

export default component.exports